/*
 * Copyright (C) 2025 SimpliCity Digital Inc - All Rights Reserved
 */

import React, { useEffect, useState } from "react";
import Lightbox from "yet-another-react-lightbox";
import Inline from "yet-another-react-lightbox/plugins/inline";
import Thumbnails from "yet-another-react-lightbox/plugins/thumbnails";
import { useAuth } from "cms/auth/hooks/useAuth";
import { generateImageSlide } from "./utils";
import { isArrayNotEmpty } from "cms/utils/empty-exists";
import { getFieldValues } from "cms/fields/_helpers/helpers";

const ImageGalleryFilmstrip = (props) => {

    const field = props?.field;
    const { token } = useAuth();
    const [slides, setSlides] = useState([]);
    const values = getFieldValues(field);

    useEffect(() => {
        if (isArrayNotEmpty(values)) {
            generateImageSlide(values, token)
                .then((result) => setSlides(result));
        }
    }, [token, values]);

    return (
        <div className='simplicity-image-list-item'>
            {isArrayNotEmpty(slides) &&
                <div style={{ width: "100%", maxWidth: "900px", aspectRatio: "3 / 2" }}>
                    <Lightbox
                        slides={slides}
                        style={{
                            width: "100%",
                            maxWidth: "900px",
                            aspectRatio: "3 / 2",
                            margin: "0 auto",
                        }}
                        plugins={[Inline, Thumbnails]}
                    />
                </div>
            }
        </div>
    );
};

export { ImageGalleryFilmstrip };
